import {reaction} from "mobx";
import {observer} from "mobx-react";
import React from "react";
import {PixiSpineAnimation} from "../../services/pixi-app/pixi-spine-animation";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";


export interface AnimatedTopImageComponentProps {
    image: string;
}
@observer
export class AnimatedTopImageComponent extends OrbitComponent<AnimatedTopImageComponentProps> {
    private _animationElement: HTMLDivElement | null = null;
    private _reactionDisposer = null;
    private _bannerPixiAnimation: PixiSpineAnimation = null;

    componentDidMount(): void {
        this._startAnimation();
        this._reactionDisposer = reaction(() =>
            [
                this.services.mediaQuery.lAndBelow,
                this.services.mediaQuery.sAndBelow
            ],
            (data) => {
                this._stopAnimation();
                this._startAnimation();
            })
    }


    componentWillUnmount(): void {
        this._stopAnimation();
        this._reactionDisposer();
    }

    private _createAnimation() {
        let defautSkinConfiguration = {
            width: 1750,
            height: 200,
            name: "desktop",
            scale: 1
        }

        if (this.services.mediaQuery.lAndBelow) {
            defautSkinConfiguration.width = 1024;
            defautSkinConfiguration.height = 165;
            defautSkinConfiguration.name = "tablet";
            defautSkinConfiguration.scale = 1;
        }

        if (this.services.mediaQuery.sAndBelow) {
            defautSkinConfiguration.width = 414;
            defautSkinConfiguration.height = 105;
            defautSkinConfiguration.name = "mobile";
            defautSkinConfiguration.scale = 0.6;
        }
        return new PixiSpineAnimation(
            this.services,
            {
                width: defautSkinConfiguration.width, height: defautSkinConfiguration.height, force2DCanvasContext: true
            },
            [{name: 'slotsAnimatedBannerResource', jsonUrl: this.props.image}],
            {
                render: ({pixiApp, spineAnimations}) => {
                    let spineAnimation = spineAnimations.slotsAnimatedBannerResource;
                    spineAnimation.skeleton.setSkinByName(defautSkinConfiguration.name);
                    spineAnimation.skeleton.setSlotsToSetupPose();

                    // set the position and scale
                    spineAnimation.x = pixiApp.screen.width / 2;
                    spineAnimation.y = pixiApp.screen.height / 2;
                    spineAnimation.scale.set(defautSkinConfiguration.scale);

                    const runAnimation = () => {
                        spineAnimation.state.setAnimation(0, "intro", false);
                        spineAnimation.state.addAnimation(0, "loop", true, 0);
                    }

                    runAnimation();
                }
            },
            {
                width: "100%"
            }
        );
    }

    private async _startAnimation() {
        this._bannerPixiAnimation = this._createAnimation();
        this._bannerPixiAnimation.start();
        this._bannerPixiAnimation.attachToDOM(this._animationElement);
    }

    private _stopAnimation() {
        this._bannerPixiAnimation.dispose();
    }

    private captureAnimationDivElement = (el: HTMLDivElement | null) => {
        this._animationElement = el;
    }

    render() {
        return (<>
            <div style={{position: "absolute", top: 0, left: 0, bottom: 0, width: "100%"}}
                ref={this.captureAnimationDivElement}>
            </div>
            {/* when rendering the animated banner, on mobile, because of the canvas we cannot scroll the page when holding from the canvas element.
            So we put this div in front of it so when we touch the screen, the target element is the div not the canvas */}
            <div style={{position: "absolute", top: 0, left: 0, bottom: 0, width: "100%", zIndex: 5}} />
        </>);
    }
}